module.exports = __webpack_public_path__ + "media/images/icons/star-black-a29414b9024c75ffaf8559275361691d.svg";